import { AddressMapper } from 'ish-core/models/address/address.mapper';
import { LineItemData } from 'ish-core/models/line-item/line-item.interface';
import { LineItemMapper } from 'ish-core/models/line-item/line-item.mapper';
import {
  RecurringOrderData,
  RecurringOrderDetailData,
} from 'ish-core/models/recurring-order/recurring-order.interface';

export class RecurringOrderBucketMapper {
  static fromShippingBuckets(data: RecurringOrderDetailData, included?: RecurringOrderData['included']) {
    const shippingBuckets = data.shippingBuckets;

    if (!shippingBuckets?.length) {
      return [];
    }

    const addressMap = new Map(data.addresses?.map(a => [a.urn, a]) ?? []);

    const shippingMethodMap = new Map(data.shippingMethods?.map(sm => [sm.id, sm]) ?? []);

    const lineItemMap = new Map(data.lineItems?.map(li => [li.id, li]) ?? []);

    return shippingBuckets.map(bucket => {
      const shipToAddressData = addressMap.get(bucket.shipToAddress);
      const shippingMethodData = shippingMethodMap.get(bucket.shippingMethod);

      return {
        id: bucket.id,
        shipToAddress: shipToAddressData ? AddressMapper.fromData(shipToAddressData) : undefined,

        shippingMethod: shippingMethodData,

        lineItems: bucket.lineItems
          .map(id => lineItemMap.get(id))
          .filter((item): item is LineItemData => Boolean(item))
          .map(item => LineItemMapper.fromData(item, included?.lineItems_discounts, included?.lineItems_warranty)),
      };
    });
  }
}
